import { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { useAppToast } from "@ui-seeker/app"
import { formatDate, FORMAT_DATE_BACK, isEmpty, postSubmit, scrollToComponent, stringToDate } from "@ui-seeker/utils"

import { useMarketAnalyzerRoleConfig } from "Pages/Pricing/MarketAnalyzer/@hooks"
import { marketAnalyzerEvolutionOffersFilters } from "Pages/Pricing/MarketAnalyzer/@signals"


export default function usePricingDiscountOffersEvolutionData() {
	const { showToast } = useAppToast()
	const { urlApiChart } = useMarketAnalyzerRoleConfig()

	const dataEvolution = useSignal({})
	const dataEvolutionKeys = useSignal({})
	const chartColors = useSignal({})
	const skuName = useSignal("")
	const isLoadingDataEvolution = useSignal(false)
	const evolutionLabel = useSignal("")
	const dateRange = useSignal([])

    useEffect(() => {
		if (!isEmpty(marketAnalyzerEvolutionOffersFilters.value)) batch(() => {
			isLoadingDataEvolution.value = true
            dataEvolution.value = {}
			showToast.promise(postSubmit(`${urlApiChart}/share-mbl-evolution`, marketAnalyzerEvolutionOffersFilters.value).then(res => batch(() => {
                dataEvolution.value = res.chart
				chartColors.value = res.colors
				dataEvolutionKeys.value = res.chartKeys
				evolutionLabel.value = res.label
				dateRange.value = [stringToDate(marketAnalyzerEvolutionOffersFilters.value.startDate), stringToDate(marketAnalyzerEvolutionOffersFilters.value.endDate)]
                isLoadingDataEvolution.value = false
			})).catch(() => {
				isLoadingDataEvolution.value = false
				showToast.error()
			}
            ).finally(() => scrollToComponent('evolution-chart')))
		}) 

		if (isEmpty(marketAnalyzerEvolutionOffersFilters.value)) batch( () => {
			dataEvolution.value = {}
			dataEvolutionKeys.value = {}
			chartColors.value = {}
			skuName.value = ""
			evolutionLabel.value = ""
		})

	}, [JSON.stringify(marketAnalyzerEvolutionOffersFilters.value)]);

    const onChange = (e) => {
		batch(() => {
			dateRange.value = e
			marketAnalyzerEvolutionOffersFilters.value = {
				...marketAnalyzerEvolutionOffersFilters.value,
				startDate: formatDate(e[0], { format: FORMAT_DATE_BACK }),
				endDate: formatDate(e[1], { format: FORMAT_DATE_BACK })
			}
		})
	}
	
	const resetEvolutionData = () => batch(() => {
		dataEvolution.value = {}
		dataEvolutionKeys.value = {}
		chartColors.value = {}
		marketAnalyzerEvolutionOffersFilters.value = {}
		evolutionLabel.value = ""
	})

	return {
		dataEvolution: dataEvolution.value,
		isLoadingDataEvolution: isLoadingDataEvolution.value,
		dataEvolutionKeys: dataEvolutionKeys.value,
		chartColors: chartColors.value,
		evolutionLabel: evolutionLabel.value,
		dateRange: dateRange.value,

		onChange,
        resetEvolutionData
	}
}